import React,{useState} from 'react';

const EssentialBills = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
  const handleClick = (e) => {
    const buttonValue = e.target.value;
    setClickedButton(buttonValue);
    onNext(buttonValue);
  }
  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Struggled With Essential Bills?</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">At any point when you applied for or held the credit card, were you behind on any priority bills or essential payments?</p>
        <div className="qs-stack">
          <button 
            type="button"
            value={407} 
            className={`qs-btn qs-btn--yes qs-btn--full ${clickedButton == 407 ? 'btn-active' : ''}`}
            onClick={handleClick}
            >
              Yes</button>
          <button 
            type="button"
            value={408} 
            className={`qs-btn qs-btn--outline qs-btn--full ${clickedButton == 408 ? 'btn-active' : ''}`}
            onClick={handleClick}
            >
              No</button>
          <button 
            type="button"
            value={409} 
            className={`qs-btn qs-btn--outline qs-btn--full ${clickedButton == 409 ? 'btn-active' : ''}`}
            onClick={handleClick}
            >
              Not sure</button>
        </div>
      </div>
    </>
  );
};

export default EssentialBills;
